import React from 'react'

export type I18nInternalContextType = {
  namespace: string
  isI18nResourceLoading: number
}

export const I18nInternalContext = React.createContext<I18nInternalContextType>(
  (undefined as any) as I18nInternalContextType
)
